import { render, staticRenderFns } from "./QaAnswerModal.vue?vue&type=template&id=0b9c5635&scoped=true&"
import script from "@/scripts/QA/Question/components/QaAnswerModal?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/QaAnswerModal?vue&type=script&lang=js&"
import style0 from "./QaAnswerModal.vue?vue&type=style&index=0&id=0b9c5635&scoped=true&lang=css&"
import style1 from "./QaAnswerModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9c5635",
  null
  
)

export default component.exports